import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import Offcanvas from "./Offcanvas";

const Header: React.FC = () => {
  const [activateOffcanvas, setActivateOffcanvas] = useState<boolean>(false);
  const [activateSearch, setActivateSearch] = useState<boolean>(false);

    const handleClickOffcanvas = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setActivateOffcanvas(!activateOffcanvas);
    }

//   const handleSearch = (e: React.MouseEvent<HTMLInputElement>) => {
//     e.preventDefault();
//     setActivateSearch(!activateSearch);
//   };

//   const getMenuActiveStatus = (status: boolean) => {
//     setActivateOffcanvas(status);
//   };

  return (
    <header className="px-1 w-full">
        <div style={{ width: "3.5rem", height: "3.5rem", overflow: "hidden" }}>
            <Link to={`/`}>
                <img src={`/assets/img/koku.png`} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </Link>
            {/* <div className="col d-flex justify-content-center"> </div>
            <div className="col-auto">
                <button className="header-menu-trigger" onClick={handleClickOffcanvas}>
                    <ReactSVG src={`${process.env.PUBLIC_URL}/assets/img/icons/menu.svg`} />
                </button>
            </div> */}
        </div>
        {/* <Offcanvas show={activateOffcanvas} activeStatus={getMenuActiveStatus} /> */}
    </header>
  );
};

export default Header;
